import fetchPayload from './dynamicPayload';
import { createEmv } from './emvHandler';
import { PixElementType, } from './types/pixElements';
import { toBase64 } from './utils/qrcodeGenerator';
export function generatePixObject(elements) {
    const emvCode = createEmv(elements);
    if (elements.type === PixElementType.STATIC) {
        const staticObject = {
            ...elements,
            toBRCode: () => emvCode,
            toImage: () => toBase64(emvCode),
        };
        const throwIfError = () => ({
            ...staticObject,
            throwIfError: () => staticObject,
        });
        return {
            ...staticObject,
            throwIfError,
        };
    }
    if (elements.type === PixElementType.DYNAMIC) {
        const dynamicObject = {
            ...elements,
            toBRCode: () => emvCode,
            fetchPayload: ({ DPP, codMun }) => fetchPayload({ url: elements.url, DPP, codMun }),
            toImage: () => toBase64(emvCode),
        };
        const throwIfError = () => ({
            ...dynamicObject,
            throwIfError: () => dynamicObject,
        });
        return {
            ...dynamicObject,
            throwIfError,
        };
    }
    throw new Error('Invalid Pix type');
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzZW1ibGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Fzc2VtYmxlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLFlBQVksTUFBTSxrQkFBa0IsQ0FBQztBQUM1QyxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sY0FBYyxDQUFDO0FBQ3pDLE9BQU8sRUFHTCxjQUFjLEdBR2YsTUFBTSxxQkFBcUIsQ0FBQztBQUM3QixPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0seUJBQXlCLENBQUM7QUFFbkQsTUFBTSxVQUFVLGlCQUFpQixDQUFDLFFBQXFCO0lBQ3JELE1BQU0sT0FBTyxHQUFHLFNBQVMsQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUNwQyxJQUFJLFFBQVEsQ0FBQyxJQUFJLEtBQUssY0FBYyxDQUFDLE1BQU0sRUFBRTtRQUMzQyxNQUFNLFlBQVksR0FBRztZQUNuQixHQUFHLFFBQVE7WUFDWCxRQUFRLEVBQUUsR0FBRyxFQUFFLENBQUMsT0FBTztZQUN2QixPQUFPLEVBQUUsR0FBRyxFQUFFLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQztTQUNqQyxDQUFDO1FBRUYsTUFBTSxZQUFZLEdBQUcsR0FBRyxFQUFFLENBQUMsQ0FBQztZQUMxQixHQUFHLFlBQVk7WUFDZixZQUFZLEVBQUUsR0FBRyxFQUFFLENBQUMsWUFBWTtTQUNqQyxDQUFDLENBQUM7UUFFSCxPQUFPO1lBQ0wsR0FBRyxZQUFZO1lBQ2YsWUFBWTtTQUNNLENBQUM7S0FDdEI7SUFDRCxJQUFJLFFBQVEsQ0FBQyxJQUFJLEtBQUssY0FBYyxDQUFDLE9BQU8sRUFBRTtRQUM1QyxNQUFNLGFBQWEsR0FBRztZQUNwQixHQUFHLFFBQVE7WUFDWCxRQUFRLEVBQUUsR0FBRyxFQUFFLENBQUMsT0FBTztZQUN2QixZQUFZLEVBQUUsQ0FBQyxFQUFFLEdBQUcsRUFBRSxNQUFNLEVBQUUsRUFBRSxFQUFFLENBQ2hDLFlBQVksQ0FBQyxFQUFFLEdBQUcsRUFBRSxRQUFRLENBQUMsR0FBRyxFQUFFLEdBQUcsRUFBRSxNQUFNLEVBQUUsQ0FBQztZQUNsRCxPQUFPLEVBQUUsR0FBRyxFQUFFLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQztTQUNqQyxDQUFDO1FBRUYsTUFBTSxZQUFZLEdBQUcsR0FBRyxFQUFFLENBQUMsQ0FBQztZQUMxQixHQUFHLGFBQWE7WUFDaEIsWUFBWSxFQUFFLEdBQUcsRUFBRSxDQUFDLGFBQWE7U0FDbEMsQ0FBQyxDQUFDO1FBRUgsT0FBTztZQUNMLEdBQUcsYUFBYTtZQUNoQixZQUFZO1NBQ08sQ0FBQztLQUN2QjtJQUNELE1BQU0sSUFBSSxLQUFLLENBQUMsa0JBQWtCLENBQUMsQ0FBQztBQUN0QyxDQUFDIn0=